import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import qs from "qs";
import { qsSettings } from "utils/apiHelpers";
import token from "../common/csrf-token";

export const coreApiSlice = createApi({
  reducerPath: "coreApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `https://${window.location.hostname}`,
    prepareHeaders: headers => {
      headers.set("Accept", "application/json");
      headers.set("X-CSRF-Token", token);
      return headers;
    },
    paramsSerializer: params => qs.stringify(params, qsSettings)
  }),
  endpoints: () => ({}),
  tagTypes: ["Campaign", "EmailSetting", "AccessLevelSetting", "FacebookPage", "Transaction"]
});

export default coreApiSlice;
